module.exports = __webpack_public_path__ + "img/product-5.38929b78.jpg";